import t4Templating from "refractor/t4-templating";
export default t4Templating;